<div
  *ngIf="!loading"
  class="px-3 pt-8">
  <p class="font-medium text-2xl">Для начала работы с сервисом выберите откуда будет производиться экспорт данных</p>

  <div class="flex flex-wrap justify-content-center align-items-center gap-5 mt-4">
    <button
      pButton
      type="button"
      label="Выписка из Банка"
      class="p-button-lg"
      style="min-width: 172px !important; max-width: 172px !important"
      (click)="stepChange.emit(WelcomeSystemStepEnum.IMPORT_SELECTION_BANK)"></button>

    <button
      pButton
      type="button"
      label="1С Предприяте 8.3"
      style="min-width: 172px !important; max-width: 172px !important"
      class="p-button-lg"
      (click)="stepChange.emit(WelcomeSystemStepEnum.IMPORT_FROM_1C)"></button>

    <button
      pButton
      type="button"
      label="Демо-аккаунт"
      style="min-width: 172px !important; max-width: 172px !important"
      class="p-button-lg"
      (click)="clickDemoAccount()"></button>
  </div>

  <div class="flex justify-content-center mt-8">
    <p
      class="text-sm text-gray-500 hover:frm-color-blue-light cursor-pointer"
      (click)="reminderWelcome()">
      Напомнить позже
    </p>
  </div>
</div>

<crm-spinner
  *ngIf="loading"
  top="mt-3 pt-3"></crm-spinner>
